<template>
  <div id="Weebly" style="margin-left:10%;padding-top:5rem">
    <img
    src="@/assets/img/integration/Weebly_logo.png"
    style="max-width: 35%; margin:auto; display:block"
    />
    <h2 class="mt-5 documentation-header">How to Setup a Cense AI Chatbot for Weebly</h2>
    <div style="margin-top: 3%">
      <h6>1. Login to your Weebly account with your credentials</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>2. Go to “My Site” then Select your website → Edit</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>3. Select “Settings”</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>4. Click on “Search Engine Optimizations (SEO)”</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>
        5. Copy the Widget Code from Weebly
        Settings (in Miscellaneous Menu of Cense Portal), then paste it in
        “Footer Code” box in the Weebly settings.
      </h6>
    </div>
    <div style="margin-top: 3%">
      <h6>6. Click on “Save”</h6>
    </div>
    <div style="margin-top: 3%">
      <h6>7. Publish your website and its Done!</h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "weebly",
};
</script>
<style scoped>
h6 {
  font: normal normal normal 1rem/2.5rem Poppins;
}
</style>
